
import { dataMaxSelectedBroadcast } from '../../../store/params';
import { headers, search } from './attributes';
import { date, showAlert } from '../../../lib/helpers';

export default {
  data: () => ({
    show: false,
    view: false,
    limit: '5',
    page: '1',
    options: {},
    dialog: false,
    dialogDelete: false,
    headers,
    editedIndex: -1,
    search,
    selectedRow: '',
    dateFormatted: '',
    dateMenu: false,
    maxSelected: dataMaxSelectedBroadcast,
  }),

  computed: {
    flashErrorMessage() {
      return this.$store.state.broadcast.broadcastEmail.flashErrorMessage;
    },

    flashError: {
      get() {
        return this.$store.state.broadcast.broadcastEmail.flashError;
      },
      set() {
        this.$store.commit('broadcast/broadcastEmail/setFlashErrorMessage', '');
      },
    },

    errorValidation() {
      return this.$store.state.broadcast.broadcastEmail.errors;
    },
    loading() {
      return this.$store.state.broadcast.broadcastEmail.loading;
    },
    loadingActiveUser() {
      return this.$store.state.users.loadingActiveUser;
    },
    merchants() {
      return this.$store.state.broadcast.broadcastEmail.allMerchants;
    },
    totalPage() {
      return this.$store.state.broadcast.broadcastEmail.totalPage;
    },
    totalMerchants() {
      return this.$store.state.broadcast.broadcastEmail.totalMerchants;
    },
    selectedData: {
      set(data) {
        this.$store.commit('broadcast/broadcastEmail/setSelectedData', data);
      },
      get() {
        return this.$store.state.broadcast.broadcastEmail.selectedData;
      },
    },
    dataEdit() {
      return this.$store.state.broadcast.broadcastEmail.dataEdit;
    },
  },

  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },

    'search.created_at': {
      handler() {
        this.dateFormatted = this.formatDate(this.search.created_at);
        this.getData();
      },
    },

    show() {
      if (!this.show) {
        this.clearSearch();
        this.$nextTick(() => {
          this.getData();
        });
      }
    },
    selectedData: {
      handler() {
        if (this.selectedData.length > this.maxSelected) {
          showAlert(
            this.$store,
            `Limit selected data is ${this.maxSelected} !`,
            'mdi-alert',
            'red'
          );
          this.selectedData.splice(
            this.maxSelected,
            this.selectedData.length - 1
          );
        }
      },
    },
  },

  mounted() {
    const selected = this.$store.state.broadcast.broadcastEmail.selectedData;
    if (selected != null) {
      this.selectedData = selected;
    }
  },

  methods: {
    selectRow(index) {
      if (this.selectedRow !== index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    clearSearch() {
      this.search.merchant_name = '';
      this.search.mid = '';
      this.search.email = '';
      this.search.postal_code = '';
      this.getData();
    },

    clearSelected() {
      this.selectedData = [];
    },

    getData() {
      this.$store.commit('broadcast/broadcastEmail/setFlashErrorMessage', '');
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store
        .dispatch('broadcast/broadcastEmail/fetchData', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
        })
        .then(() => {
          if (this.totalPage < page) {
            if (this.totalPage === 0) {
              this.options.page = 1;
            } else {
              this.options.page = this.totalPage;
            }
          }
        });
    },

    goToBroadcastForm(broadcastAll) {
      if (!broadcastAll) {
        if (this.selectedData.length < 1) {
          showAlert(this.$store, 'Data must be selected !', 'mdi-alert', 'red');
          return;
        }
      } else {
        this.selectedData = [];
      }
      this.$store.commit(
        'broadcast/broadcastEmail/setBroadcastAll',
        broadcastAll
      );
      if (this.dataEdit != null) {
        this.$router.push(`/broadcast/broadcast/edit/${this.dataEdit.data.id}`);
      } else {
        this.$router.push('/broadcast/broadcast/add');
      }
    },

    closeFlash() {
      this.$store.commit('broadcast/broadcastEmail/setFlashErrorMessage', '');
    },

    formatDate(dateVal) {
      if (!dateVal) return null;

      const [year, month, day] = dateVal.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate(dateVal) {
      if (!dateVal) return null;

      const [day, month, year] = dateVal.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.dataEdit == null) {
      next();
    } else if (to.path.indexOf('/broadcast/broadcast') == -1) {
      const answer = window.confirm(
        'Do you really want to leave? you have unsaved changes!'
      );
      if (answer) {
        this.$store.commit('broadcast/broadcastEmail/clearDetail');
        this.$store.commit('broadcast/broadcastEmail/setDataEdit', null);
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
};